export default __webpack_public_path__ + "static/media/package1.631d0621.png";